import { apiSlice } from ".";

export const notificationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllNotification: builder.query({
      query: (agencyId) => ({
        url: `/NotificationsTables/GetNotificationsWithNames?receiverid=${agencyId}&type=2`,
        method: "GET",
      }),
      providesTags: ["notification"],
    }),
    getAllNotificationById: builder.query({
      query: (id) => ({
        url: `/NotificationsTables/NotificationsTables/${id}`,
        method: "GET",
      }),
      providesTags: ["notification"],
    }),
    readNotification: builder.mutation({
      query: (id) => ({
        url: `/NotificationsTables/UpdateReadStatus/${id}`,
        method: "POST",
      }),
      invalidatesTags: ["notification"],
    }),
  }),
});

export const {
  useGetAllNotificationQuery,
  useGetAllNotificationByIdQuery,
  useReadNotificationMutation,
} = notificationApi;
